import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, MenuItem, Chip } from '@material-ui/core';
import { InvertedChevronIcon, DialogIcon } from 'components/Icons';
import { FilterType } from './index';
import useStyle from './style';

interface Props {
  respondidos: number;
  pendentes: number;
  onChange: (value: FilterType | undefined) => void;
}

export default function ({ respondidos, pendentes, onChange }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();

  const handleChange = useCallback(
    (event: React.ChangeEvent<{ value: unknown }>) => {
      onChange(event.target.value as FilterType | undefined);
    },
    [onChange]
  );

  return (
    <div className={classes.filtro}>
      <TextField
        label={t('AssessorMensagens.filtrar')}
        onChange={handleChange}
        SelectProps={{
          IconComponent: () => <InvertedChevronIcon className={classes.dropdownIcon} />,
        }}
        className={classes.select}
        fullWidth
        select
      >
        <MenuItem value={undefined}>{t('AssessorMensagens.sem-filtro')}</MenuItem>
        <MenuItem value="respondido">{t('AssessorMensagens.filtro.respondido')}</MenuItem>
        <MenuItem value="pendente">{t('AssessorMensagens.filtro.pendente')}</MenuItem>
      </TextField>
      <Chip
        label={t('AssessorMensagens.respondido', { count: respondidos })}
        size="small"
        className={[classes.chips, classes.chipRespondidos].join(' ').trim()}
        icon={<DialogIcon />}
      />
      <Chip
        label={t('AssessorMensagens.pendente', { count: pendentes })}
        size="small"
        className={[classes.chips, classes.chipPendentes].join(' ').trim()}
        icon={<DialogIcon />}
      />
    </div>
  );
}
